export const CREATE_CLUB_QUERY_PARAM = "create-club";

export const hasCreateClubIntent = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return params.get(CREATE_CLUB_QUERY_PARAM) === "1";
};

export const createClubRedirectPath = (): string =>
  `/?${CREATE_CLUB_QUERY_PARAM}=1`;
